import { routenames } from '@/router/routenames';
import type { NavigationEntryRaw } from '../types';

export const qaEquipmentNavigationRaw: NavigationEntryRaw[] = [
  {
    titleI18n: 'Entity_other',
    route: { name: routenames.qaEquipment.index },
  },
];
